import { PAGES, PAGES_HEADS, TEST_SYSTEM } from "@/constants";
import { createRouter, createWebHistory } from "vue-router";
import { officeRoutes } from "./office";
// Страницы грузятся по требованию (отдельный файл на страницу): при входе скачивается только оболочка
// и открытая страница. Сразу — только вход, главная и 404.
import Login from "../views/Login/index.vue";
import LoginUrl from "../views/loginUrl/index.vue";
import HomeView from "../views/Main.vue";
const FinancePayments = () => import("../views/FinancePayments");
const InstallmentRefunds = () => import("@/views/InstallmentRefunds");
const ForgetPassword = () => import("../views/ForgetPassword");
const Costs = () => import("@/views/Costs");
const CreditProgramsSettings = () => import("@/views/CreditProgramsSettings");
const MarginConfigSettings = () => import("@/views/MarginConfigSettings");
const RemontRealizations = () => import("@/views/RemontRealizations");
const ChangeMaterialRequests = () => import("@/views/ChangeMaterialRequests");
const DataWith1C = () => import("@/views/DataWith1C");
const TimelineGrade = () => import("@/views/timeline/timeline-grade");
const TimelineGradeSync = () => import("@/views/timeline/timeline-grade-sync");
const TimelineRemont = () => import("@/views/timeline/timeline-remont");
const TimelineZoneReport = () => import("@/views/timeline/timeline-zone-report");
const TimelineZoneSettings = () => import("@/views/timeline/timeline-zone-settings");
const TimelineFieldSettings = () => import("@/views/timeline/timeline-field-settings");
const TimelineCompare = () => import("@/views/timeline/timeline-compare");
const TimelineMonitoring = () => import("@/views/timeline/timeline-monitoring");
const TimelineEventSettings = () => import("@/views/timeline/timeline-event-settings");
const TimelineEventLog = () => import("@/views/timeline/timeline-event-log");
// Этапы ГПР (новый режим) — экраны грузятся лениво
const WgprOverview = () => import("@/views/workgpr/Overview.vue");
const WgprRequests = () => import("@/views/workgpr/Requests.vue");
const WgprRemonts = () => import("@/views/workgpr/Remonts.vue");
const WgprRemont = () => import("@/views/workgpr/Remont.vue");
const WgprContractor = () => import("@/views/workgpr/Contractor.vue");
const WgprOkk = () => import("@/views/workgpr/Okk.vue");
const WgprPayments = () => import("@/views/workgpr/Payments.vue");
const WgprMaterials = () => import("@/views/workgpr/Materials.vue");
const WgprReports = () => import("@/views/workgpr/Reports.vue");
const WgprTemplates = () => import("@/views/workgpr/Templates.vue");
const WgprTemplateEdit = () => import("@/views/workgpr/TemplateEdit.vue");
const WgprPrices = () => import("@/views/workgpr/Prices.vue");
const WgprCheckLists = () => import("@/views/workgpr/CheckLists.vue");
const ClientsRequest = () => import("@/views/ClientRequests");
const ProviderRequests = () => import("@/views/ProviderRequests");
const ShippingPlan = () => import("@/views/ShippingPlan/index.vue");
const ProviderRequestAdditionDecisions = () => import("@/views/ProviderRequestAdditionDecisions");
const Balances = () => import("@/views/Balances");
const Materials = () => import("@/views/Materials");
const MaterialConstructorList = () => import("@/views/MaterialConstructorList");
const MaterialBaseOperations = () => import("@/views/MaterialBaseOperations");
const PromoMaterials = () => import("@/views/PromoMaterials");
const MaterialProviderList = () => import("@/views/MaterialProviderList");
const MaterialProvPriceChanges = () => import("@/views/MaterialProvPriceChanges");
const FastSearch = () => import("@/views/FastSearch");
const AgreementsJournal = () => import("@/views/AgreementsJournal");
const Handbook = () => import("@/views/handbook");
const Logging = () => import("@/views/logging");
const Profile = () => import("@/views/profile");
const ExecutiveReport = () => import("@/views/ExecutiveReport");
const CompletedStageReport = () => import("@/views/Reports/CompletedStageReport");
const ProjectReviewReport = () => import("@/views/Reports/ProjectReviewReport");
const RemontSlaReport = () => import("@/views/Reports/RemontSlaReport");
const DesignerPayReport = () => import("@/views/Reports/DesignerPayReport/index.vue");
const ClientDebtRemontReport = () => import("@/views/Reports/ClientDebtRemontReport");
const ClientRequestDebtReport = () => import("@/views/Reports/ClientRequestDebtReport/index.vue");
const ClientCashflowReport = () =>
  import("@/views/Reports/ClientCashflowReport/index.vue");
const ReportTech = () => import("@/views/Reports/ReportTech");
const ProviderRequestServiceReport = () => import("@/views/Reports/ProviderRequestServiceReport");
const KanbanV2 = () => import("@/views/kanban-v2/index.vue");
const KanbanV2Boards = () => import("@/views/kanban-v2/boards.vue");
const KanbanV2BoardSprav = () => import("@/views/kanban-v2/board-sprav.vue");
const ItSupportDevInbox = () => import("@/views/it-support-inbox/index.vue");
const ItSupportSettings = () => import("@/views/it-support-settings/index.vue");
const NotificationsInbox = () => import("@/views/notifications-inbox/index.vue");
const WarrantyRequests = () => import("@/views/WarrantyRequests");
const ContragentAvrQueue = () => import("@/views/ContragentAvrQueue");
const ClientRequestByRemontId = () => import("@/views/ClientRequests/ClientRequestByRemontId");
import NotFound from "@/views/page404";
import { handbookTitles } from "@/views/timeline/services";
const ReportGenerator = () => import("@/views/ReportGenerator");
const TechprojectRequests = () => import("@/views/techprojectRequests");
const RoomBooking = () => import("@/views/RoomBooking");
const ResidentialSettings = () => import("@/views/ResidentialSettings");
const RemarketContractorInfo = () => import("@/views/RemarketContractorInfo");
const Showrooms = () => import("@/views/Showrooms");
const ImageUrl = () => import("@/views/imageUrl");
const BufferParams = () => import("@/views/BufferParams");
const RevitBufferParams = () => import("@/views/RevitBufferParams");
const RevitData = () => import("@/views/RevitData");
const RevitPresetMaterials = () => import("@/views/RevitPresetMaterials");
const RevitPluginVersions = () => import("@/views/RevitPluginVersions");
const RevitProjectTemplates = () => import("@/views/RevitProjectTemplates");
const FlatList = () => import("@/views/FlatList");
const FrameTypes = () => import("@/views/Frames/Types");
const FramesList = () => import("@/views/Frames/List");
const ShellEstimates = () => import("@/views/ShellEstimates");
const ShellRooms = () => import("@/views/ShellRooms");
const ShellProjects = () => import("@/views/ShellProjects");
const WorkSetCheckGroups = () => import("@/views/WorkSetCheckGroups");
const WorkSetCheckGroupsLink = () => import("@/views/WorkSetCheckGroupsLink");
const FloorParams = () => import("@/views/FloorParams");
const CronJobs = () => import("@/views/CronJobs");
const CompanyKeyStore = () => import("@/views/nca/CompanyKeyStore");
const ResidentPresetList = () => import("@/views/ResidentPresetList/index.vue");
const Planirovka = () => import("@/views/Planirovka/index.vue");
const PlanirovkaV2 = () => import("@/views/PlanirovkaV2/index.vue");
const PresetKitList = () => import("@/views/PresetKitList/index.vue");
const EstimateConstructorSurfaces = () => import("@/views/EstimateConstructor/Surfaces/index.vue");
const Agreements = () => import("@/views/Agreements");
const Sync1c = () => import("@/views/Sync1c");
const DduContractor = () => import("@/views/DduContractor");
const DduResidents = () => import("@/views/DduResidents");
const ContractorCompany = () => import("@/views/handbook/contractor-company/index.vue");
const CompanyLimit = () => import("@/views/handbook/company-limit/index.vue");
const MaterialTypes = () => import("@/views/handbook/MaterialTypes/index.vue");
const MaterialSets = () => import("@/views/handbook/MaterialSets/index.vue");
const MaterialSetEdit = () => import("@/views/handbook/MaterialSets/edit.vue");
const MaterialPaints = () => import("@/views/handbook/MaterialPaints/index.vue");
const Cleaning = () => import("@/views/handbook/Cleaning/index.vue");
const RemontTermSettings = () => import("@/views/handbook/RemontTermSettings/index.vue");
const DesignerPayTariff = () => import("@/views/handbook/DesignerPayTariff/index.vue");
const PresetKitDisplayRules = () => import("@/views/handbook/PresetKitDisplayRules/index.vue");
const RenderStandard = () => import("@/views/Renders/Standard/index.vue");
const RenderPlan = () => import("@/views/Renders/Plan/index.vue");
const RenderUpload = () => import("@/views/Renders/Upload/index.vue");
const CmsBanners = () => import("@/views/cms/Banners/index.vue");
const CmsSalePoints = () => import("@/views/cms/SalePoints/index.vue");
const CmsPresetKitInfo = () => import("@/views/cms/PresetKitInfo/index.vue");
const HunterDealLimits = () => import("@/views/crm/HunterDealLimits/index.vue");
const ClientMessages = () => import("@/views/crm/ClientMessages/index.vue");

export const routes = [
  {
    path: PAGES.login,
    name: "login",
    meta: { layout: "empty", title: "Авторизация" },
    component: Login,
  },
  {
    path: PAGES.forgetPassword,
    name: "forgetPassword",
    meta: { layout: "empty", title: "Забыли пароль" },
    component: ForgetPassword,
  },
  {
    path: PAGES.main,
    name: "main",
    meta: { layout: "main" },
    component: HomeView,
  },
  {
    path: PAGES.financePayments,
    name: "financePayments",
    meta: { layout: "main", title: "Платежные поручения" },
    component: FinancePayments,
  },
  {
    path: PAGES.installmentRefunds,
    name: "installmentRefunds",
    meta: { layout: "main", title: "Рассрочка Freedom: возвраты" },
    component: InstallmentRefunds,
  },
  {
    path: PAGES.creditProgramSettings,
    name: "creditProgramSettings",
    meta: { layout: "main", title: "Настройка рассрочек/кредитов" },
    component: CreditProgramsSettings,
  },
  {
    path: PAGES.marginConfigSettings,
    name: "marginConfigSettings",
    meta: { layout: "main", title: "Настройка маржи" },
    component: MarginConfigSettings,
  },
  {
    path: PAGES.changeMaterialsRequests,
    name: "changeMaterialsRequests",
    meta: { layout: "main", title: "Заявки на изменение наличия материалов" },
    component: ChangeMaterialRequests,
  },
  {
    path: PAGES.quickSearch,
    name: "quickSearch",
    meta: { layout: "main", title: "Быстрый поиск" },
    component: FastSearch,
  },
  {
    path: PAGES.payments,
    name: "payments",
    meta: { layout: "main", title: "Ожидает оплаты" },
    component: Costs,
  },
  {
    path: PAGES.timelineGrade,
    name: "timeline_grade",
    meta: { layout: "main", padding: false, title: "Таймлайн грейда" },
    component: TimelineGrade,
  },
  {
    path: PAGES.timelineGradeSync,
    name: "timeline_grade_sync",
    meta: { layout: "main", title: "Синхронизация грейда" },
    component: TimelineGradeSync,
  },
  {
    path: PAGES.timelineRemont,
    name: "timeline_remont",
    meta: { layout: "main", padding: false, title: "Таймлайн ремонта" },
    component: TimelineRemont,
  },
  {
    path: PAGES.timelineZoneReport,
    name: "timelineZoneReport",
    meta: { layout: "main", title: "Отчёт по зонам таймлайна" },
    component: TimelineZoneReport,
  },
  {
    path: PAGES.timelineZoneSettings,
    name: "timelineZoneSettings",
    meta: { layout: "main", title: "Настройка зон таймлайна" },
    component: TimelineZoneSettings,
  },
  {
    path: PAGES.timelineFieldSettings,
    name: "timelineFieldSettings",
    meta: { layout: "main", title: "Настройка полей детализации" },
    component: TimelineFieldSettings,
  },
  {
    path: PAGES.timelineCompare,
    name: "timelineCompare",
    meta: { layout: "main", title: "Сравнение шагов таймлайна" },
    component: TimelineCompare,
  },
  {
    path: PAGES.timelineMonitoring,
    name: "timelineMonitoring",
    meta: { layout: "main", title: "Мониторинг таймлайна" },
    component: TimelineMonitoring,
  },
  {
    path: PAGES.timelineEventSettings,
    name: "timelineEventSettings",
    meta: { layout: "main", title: "Настройки событий таймлайна" },
    component: TimelineEventSettings,
  },
  // ── Этапы ГПР (новый режим) ──
  { path: PAGES.wgprOverview, name: "wgprOverview", meta: { layout: "main", title: "Этапы ГПР: обзор" }, component: WgprOverview },
  { path: PAGES.wgprRequests, name: "wgprRequests", meta: { layout: "main", title: "Этапы ГПР: заявки" }, component: WgprRequests },
  { path: PAGES.wgprRemonts, name: "wgprRemonts", meta: { layout: "main", title: "Этапы ГПР: ремонты" }, component: WgprRemonts },
  { path: PAGES.wgprRemont, name: "wgprRemont", meta: { layout: "main", title: "ГПР ремонта", withParam: true }, component: WgprRemont },
  { path: PAGES.wgprContractor, name: "wgprContractor", meta: { layout: "main", title: "Этапы ГПР: подрядчик" }, component: WgprContractor },
  { path: PAGES.wgprOkk, name: "wgprOkk", meta: { layout: "main", title: "Этапы ГПР: ОКК" }, component: WgprOkk },
  { path: PAGES.wgprPayments, name: "wgprPayments", meta: { layout: "main", title: "Этапы ГПР: платежи" }, component: WgprPayments },
  { path: PAGES.wgprMaterials, name: "wgprMaterials", meta: { layout: "main", title: "Этапы ГПР: материалы" }, component: WgprMaterials },
  { path: PAGES.wgprReports, name: "wgprReports", meta: { layout: "main", title: "Этапы ГПР: отчёты" }, component: WgprReports },
  { path: PAGES.wgprTemplates, name: "wgprTemplates", meta: { layout: "main", title: "Этапы ГПР: шаблоны" }, component: WgprTemplates },
  { path: PAGES.wgprTemplate, name: "wgprTemplate", meta: { layout: "main", title: "Шаблон ГПР", withParam: true }, component: WgprTemplateEdit },
  { path: PAGES.wgprPrices, name: "wgprPrices", meta: { layout: "main", title: "Этапы ГПР: расценки" }, component: WgprPrices },
  { path: PAGES.wgprCheckLists, name: "wgprCheckLists", meta: { layout: "main", title: "Этапы ГПР: чек-листы" }, component: WgprCheckLists },
  {
    path: PAGES.timelineEventLog,
    name: "timelineEventLog",
    meta: { layout: "main", title: "Журнал выполнений таймлайна" },
    component: TimelineEventLog,
  },
  {
    path: PAGES.techprojectRequests,
    name: "techprojectRequests",
    meta: { layout: "main", title: "Заявки для проектировщиков" },
    component: TechprojectRequests,
  },
  {
    path: PAGES.compareDataOneC,
    name: "compareDataOneC",
    meta: { layout: "main", title: "Сверка поступлений с 1C" },
    component: DataWith1C,
  },
  {
    path: PAGES.profile,
    name: "profile",
    meta: { layout: "main", title: "Профиль" },
    component: Profile,
  },
  {
    path: PAGES.warrantyRequests,
    name: "warrantyRequests",
    meta: { layout: "main", title: "Заявки для гарантии" },
    component: WarrantyRequests,
  },
  {
    path: PAGES.contragentAvrQueue,
    name: "contragentAvrQueue",
    meta: { layout: "main", title: "Создание АВР" },
    component: ContragentAvrQueue,
  },
  {
    path: PAGES.request,
    name: "request",
    meta: { layout: "main", title: "Заявка", withParam: true },
    component: ClientsRequest,
  },
  {
    path: PAGES.providerRequests,
    name: "providerRequests",
    meta: { layout: "main", title: "Заявки поставщикам" },
    component: ProviderRequests,
  },
  {
    path: PAGES.shippingPlan,
    name: "shippingPlan",
    meta: { layout: "main", title: "Планирование материалов поставщиком" },
    component: ShippingPlan,
  },
  {
    path: PAGES.providerRequestAdditionDecisions,
    name: "providerRequestAdditionDecisions",
    meta: { layout: "main", title: "Согласование доп. заявок" },
    component: ProviderRequestAdditionDecisions,
  },
  {
    path: PAGES.balances,
    name: "balances",
    meta: { layout: "main", title: "Балансы" },
    component: Balances,
  },
  {
    path: PAGES.materials,
    name: "materials",
    meta: { layout: "main", title: "Список материалов" },
    component: Materials,
  },
  {
    path: PAGES.materialConstructorList,
    name: "materialConstructorList",
    meta: { layout: "main", title: "Список материалов (Конструктор)" },
    component: MaterialConstructorList,
  },
  {
    path: PAGES.materialBaseOperations,
    name: "materialBaseOperations",
    meta: { layout: "main", title: "Базовые операции" },
    component: MaterialBaseOperations,
  },
  {
    path: PAGES.promoMaterials,
    name: "promoMaterials",
    meta: { layout: "main", title: "Скидочные материалы" },
    component: PromoMaterials,
  },
  {
    path: PAGES.materialProviderList,
    name: "materialProviderList",
    meta: {
      layout: "main",
      title: "Список материалов поставщиков для SmartRemont",
    },
    component: MaterialProviderList,
  },
  {
    path: PAGES.materialProvPriceChanges,
    name: "materialProvPriceChanges",
    meta: { layout: "main", title: "Запросы на изменение цен" },
    component: MaterialProvPriceChanges,
  },
  {
    path: PAGES.remontPage,
    name: "remont",
    meta: { layout: "main" },
    component: ClientRequestByRemontId,
  },
  {
    path: PAGES.handbook,
    name: "handbook",
    meta: {
      layout: "main",
      defaultTitle: "Справочник",
      withParamType: true,
      titles: handbookTitles,
    },
    component: Handbook,
  },
  {
    path: PAGES.agreementsJournal,
    name: "agreementsJournal",
    meta: { layout: "main", title: "Журнал договоров" },
    component: AgreementsJournal,
  },
  {
    path: PAGES.executiveReports,
    name: "executiveReports",
    meta: { layout: "main", title: "Отчеты для руководителей" },
    component: ExecutiveReport,
  },
  {
    path: PAGES.completedStageReport,
    name: "completedStageReport",
    meta: { layout: "main", title: "Отчёт по завершению этапа" },
    component: CompletedStageReport,
  },
  {
    path: PAGES.designerPayReport,
    name: "designerPayReport",
    meta: { layout: "main", title: "Отчёт по расчёту ЗП проектировщиков" },
    component: DesignerPayReport,
  },
  {
    path: PAGES.clientDebtRemontReport,
    name: "clientDebtRemontReport",
    meta: { layout: "main", title: "Отчёт по задолженности клиента в ремонте" },
    component: ClientDebtRemontReport,
  },
  {
    path: PAGES.clientRequestDebtReport,
    name: "clientRequestDebtReport",
    meta: { layout: "main", title: "Задолженность клиентов по заявке" },
    component: ClientRequestDebtReport,
  },
  {
    path: PAGES.clientCashflowReport,
    name: "clientCashflowReport",
    meta: { layout: "main", title: "План-факт Cash In" },
    component: ClientCashflowReport,
  },
  {
    path: PAGES.reportTech,
    name: "reportTech",
    meta: { layout: "main", title: "Отчет по технике" },
    component: ReportTech,
  },
  {
    path: PAGES.reportProviderRequestService,
    name: "reportProviderRequestService",
    meta: { layout: "main", title: "Отчет по заявкам поставщику (Услуги)" },
    component: ProviderRequestServiceReport,
  },
  {
    path: PAGES.projectReviewReport,
    name: "projectReviewReport",
    meta: { layout: "main", title: "Оценки проектов" },
    component: ProjectReviewReport,
  },
  {
    path: PAGES.remontSlaReport,
    name: "remontSlaReport",
    meta: { layout: "main", title: "Сроки СМР" },
    component: RemontSlaReport,
  },
  {
    path: PAGES.reportGenerator,
    name: "reportGenerator",
    meta: { layout: "main", title: "Генератор отчетов" },
    component: ReportGenerator,
  },
  {
    path: PAGES.loginUrl,
    name: "loginUrl",
    meta: { layout: "check", routeHead: PAGES_HEADS.loginUrl },
    component: LoginUrl,
  },
  {
    path: PAGES.kanban,
    name: "kanban",
    meta: { layout: "main", padding: false, title: "Доски Канбан" },
    component: KanbanV2Boards,
  },
  {
    path: PAGES.kanbanBoardSprav,
    name: "kanban-board-sprav",
    meta: { layout: "main", padding: false, title: "Справочник досок" },
    component: KanbanV2BoardSprav,
  },
  {
    path: PAGES.kanbanBoard,
    name: "kanban-board",
    meta: { layout: "main", padding: false, title: "Канбан" },
    component: KanbanV2,
  },
  {
    path: "/kanban-v2/boards",
    redirect: PAGES.kanban,
  },
  {
    path: "/kanban-v2/board-sprav",
    redirect: PAGES.kanbanBoardSprav,
  },
  {
    path: "/kanban-v2",
    redirect: (to) => ({ path: PAGES.kanbanBoard, query: to.query }),
  },
  {
    path: PAGES.itSupportInbox,
    name: "it-support-inbox",
    meta: { layout: "main", padding: false, title: "IT Support Inbox" },
    component: ItSupportDevInbox,
  },
  {
    path: PAGES.itSupportSettings,
    name: "it-support-settings",
    meta: { layout: "main", padding: false, title: "IT Support — настройки" },
    component: ItSupportSettings,
  },
  {
    path: PAGES.notificationsInbox,
    name: "notifications-inbox",
    meta: { layout: "main", padding: false, title: "Уведомления" },
    component: NotificationsInbox,
  },
  {
    path: PAGES.realization,
    name: "realization",
    meta: { layout: "main", title: "Реализация" },
    component: RemontRealizations,
  },
  {
    path: PAGES.logging,
    name: "logging",
    meta: { layout: "main", title: "Логирование вызовов функций" },
    component: Logging,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    params: { pathMatch: ["not", "found"] },
    meta: { layout: "main", title: "Не найдено" },
    component: NotFound,
  },
  {
    path: PAGES.roomBooking,
    name: "roomBooking",
    meta: { layout: "main", title: "Бронирование комнат Шоурума" },
    component: RoomBooking,
  },
  {
    path: PAGES.residentialSettings,
    name: "residentialSettings",
    meta: {
      layout: "main",
      padding: false,
      title: "Настройка жилого комплекса",
    },
    component: ResidentialSettings,
  },
  {
    path: PAGES.remarketContractorInfo,
    name: "remarketContractorInfo",
    meta: { layout: "main", title: "Информация о подрядчике для Remarket" },
    component: RemarketContractorInfo,
  },
  {
    path: PAGES.contracts,
    name: "contracts",
    meta: { layout: "main", title: "Договора" },
    component: Agreements,
  },
  {
    path: PAGES.showrooms,
    name: "showrooms",
    meta: { layout: "main", title: "Шоурумы" },
    component: Showrooms,
  },
  {
    path: PAGES.imageUrl,
    name: "imageUrl",
    meta: { layout: "empty", title: "Изображение" },
    component: ImageUrl,
  },
  {
    path: PAGES.bufferParams,
    name: "bufferParams",
    meta: { layout: "main", title: "Данные с буффера" },
    component: BufferParams,
  },
  {
    path: PAGES.revitBufferParams,
    name: "revitBufferParams",
    meta: { layout: "main", title: "Данные с ревит буффера" },
    component: RevitBufferParams,
  },
  {
    path: PAGES.revitData,
    name: "revitData",
    meta: { layout: "main", title: "Данные Revit" },
    component: RevitData,
  },
  {
    path: PAGES.revitPresetMaterials,
    name: "revitPresetMaterials",
    meta: { layout: "main", title: "Revit — материалы подбора" },
    component: RevitPresetMaterials,
  },
  {
    path: PAGES.revitPluginVersions,
    name: "revitPluginVersions",
    meta: { layout: "main", title: "Revit — версии плагина" },
    component: RevitPluginVersions,
  },
  {
    path: PAGES.revitProjectTemplates,
    name: "revitProjectTemplates",
    meta: { layout: "main", title: "Revit — шаблоны проекта" },
    component: RevitProjectTemplates,
  },
  {
    path: PAGES.flatList,
    name: "flatList",
    meta: { layout: "main", title: "Список МОП" },
    component: FlatList,
  },
  {
    path: PAGES.frameTypes,
    name: "frameTypes",
    meta: { layout: "main", title: "Настройка параметров типа конструкции" },
    component: FrameTypes,
  },
  {
    path: PAGES.framesList,
    name: "framesList",
    meta: { layout: "main", title: "Настройка параметров типа конструкции" },
    component: FramesList,
  },
  {
    path: PAGES.shellEstimates,
    name: "shellEstimates",
    meta: { layout: "main", title: "Смета по черновой" },
    component: ShellEstimates,
  },
  {
    path: PAGES.shellRooms,
    name: "shellRooms",
    meta: { layout: "main", title: "Список комнат в черновой" },
    component: ShellRooms,
  },
  {
    path: PAGES.shellProjects,
    name: "shellProjects",
    meta: { layout: "main", title: "Проекты" },
    component: ShellProjects,
  },
  {
    path: PAGES.workSetCheckGroups,
    name: "workSetCheckGroups",
    meta: { layout: "main", title: "Проекты" },
    component: WorkSetCheckGroups,
  },
  {
    path: PAGES.workSetCheckGroupsLink,
    name: "workSetCheckGroupsLink",
    meta: { layout: "main", title: "Проекты" },
    component: WorkSetCheckGroupsLink,
  },
  {
    path: PAGES.floorParams,
    name: "floorParams",
    meta: { layout: "main", title: "Параметры этажей" },
    component: FloorParams,
  },
  {
    path: PAGES.cronJobs,
    name: "cronJobs",
    meta: { layout: "main", title: "Крон задачи" },
    component: CronJobs,
  },
  {
    path: PAGES.companyKeyStore,
    name: "companyKeyStore",
    meta: { layout: "main", title: "ЭЦП ключи компаний" },
    component: CompanyKeyStore,
  },
  {
    path: PAGES.residentPresetList,
    name: "residentPresetList",
    meta: { layout: "main", title: "Связки жк-пакеты" },
    component: ResidentPresetList,
  },
  {
    path: PAGES.planirovka,
    name: "planirovka",
    meta: { layout: "main", padding: false, title: "Жилые комплексы / Планировки" },
    component: Planirovka,
  },
  {
    path: PAGES.planirovkaV2,
    name: "planirovkaV2",
    meta: { layout: "main", padding: false, title: "ЖК и планировки" },
    component: PlanirovkaV2,
  },
  {
    path: PAGES.presetKitList,
    name: "presetKitList",
    meta: { layout: "main", title: "Подборы" },
    component: PresetKitList,
  },
  {
    path: PAGES.estimateConstructorSurfaces,
    name: "estimateConstructorSurfaces",
    meta: { layout: "main", title: "Поверхности" },
    component: EstimateConstructorSurfaces,
  },
  {
    path: PAGES.sync1c,
    name: "sync_1c",
    meta: { layout: "main", title: "Синхронизация 1с" },
    component: Sync1c,
  },
  {
    path: PAGES.dduContractor,
    name: "dduContractor",
    meta: { layout: "main", title: "DDU Contractor" },
    component: DduContractor,
  },
  {
    path: PAGES.dduResidents,
    name: "dduResidents",
    meta: { layout: "main", title: "ЖК по городу (ДДУ)" },
    component: DduResidents,
  },
  {
    path: PAGES.handbookContractorCompany,
    name: "handbookContractorCompany",
    meta: { layout: "main", title: "Подрядчики по компаниям" },
    component: ContractorCompany,
  },
  {
    path: PAGES.handbookCompanyLimit,
    name: "handbookCompanyLimit",
    meta: { layout: "main", title: "Лимиты компаний" },
    component: CompanyLimit,
  },
  {
    path: PAGES.handbookMaterialTypes,
    name: "handbookMaterialTypes",
    meta: { layout: "main", title: "Типы материалов" },
    component: MaterialTypes,
  },
  {
    path: PAGES.handbookMaterialSetEdit,
    name: "handbookMaterialSetEdit",
    meta: { layout: "main", title: "Набор материалов" },
    component: MaterialSetEdit,
  },
  {
    path: PAGES.handbookMaterialSets,
    name: "handbookMaterialSets",
    meta: { layout: "main", title: "Наборы материалов" },
    component: MaterialSets,
  },
  {
    path: PAGES.handbookMaterialPaints,
    name: "handbookMaterialPaints",
    meta: { layout: "main", title: "Справочник красок" },
    component: MaterialPaints,
  },
  {
    path: PAGES.handbookCleaning,
    name: "handbookCleaning",
    meta: { layout: "main", title: "Клининг" },
    component: Cleaning,
  },
  {
    path: PAGES.handbookRemontTermSettings,
    name: "handbookRemontTermSettings",
    meta: { layout: "main", title: "Сроки ремонта" },
    component: RemontTermSettings,
  },
  {
    path: PAGES.handbookDesignerPayTariff,
    name: "handbookDesignerPayTariff",
    meta: { layout: "main", title: "Матрица тарифов ЗП проектировщиков" },
    component: DesignerPayTariff,
  },
  {
    path: PAGES.handbookPresetKitDisplayRules,
    name: "handbookPresetKitDisplayRules",
    meta: { layout: "main", title: "Правила отображения пакетов" },
    component: PresetKitDisplayRules,
  },
  {
    path: PAGES.renderStandard,
    name: "renderStandard",
    meta: { layout: "main", title: "Типовые рендеры" },
    component: RenderStandard,
  },
  {
    path: PAGES.renderPlan,
    name: "renderPlan",
    meta: { layout: "main", title: "Уникальные рендеры" },
    component: RenderPlan,
  },
  {
    path: PAGES.renderUpload,
    name: "renderUpload",
    meta: { layout: "main", title: "Загрузка рендеров" },
    component: RenderUpload,
  },
  {
    path: PAGES.cmsBanners,
    name: "cmsBanners",
    meta: { layout: "main", title: "CMS: Баннеры" },
    component: CmsBanners,
  },
  {
    path: PAGES.cmsSalePoints,
    name: "cmsSalePoints",
    meta: { layout: "main", title: "CMS: Точки продаж" },
    component: CmsSalePoints,
  },
  {
    path: PAGES.cmsPresetKitInfo,
    name: "cmsPresetKitInfo",
    meta: { layout: "main", title: "CMS: Подборы" },
    component: CmsPresetKitInfo,
  },
  {
    path: PAGES.hunterDealLimits,
    name: "hunterDealLimits",
    meta: { layout: "main", title: "Лимиты сделок" },
    component: HunterDealLimits,
  },
  {
    path: PAGES.clientMessagesSent,
    name: "clientMessagesSent",
    meta: { layout: "main", title: "Обращения клиентов: отправлено", isProcessed: 0 },
    component: ClientMessages,
  },
  {
    path: PAGES.clientMessagesProcessed,
    name: "clientMessagesProcessed",
    meta: { layout: "main", title: "Обращения клиентов: обработано", isProcessed: 1 },
    component: ClientMessages,
  },  // перенос из старого Office — src/router/office/<раздел>.js
  ...officeRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Страницы грузятся по требованию, поэтому переход на другую страницу занимает время (скачивается её файл).
// Если уходящая страница в это время переписывает свой адрес (router.replace по таймеру/наблюдателю —
// синхронизация фильтров в query), такой replace отменил бы переход и вернул пользователя назад.
// Пока идёт переход на другую страницу, replace на адрес уходящей страницы пропускаем.
let leavingPath = null;
router.beforeEach((to, from) => {
  if (from.matched.length && to.path !== from.path) leavingPath = from.path;
});
router.afterEach(() => {
  leavingPath = null;
});
// После выкладки новой версии у открытой старой вкладки файлов страниц уже нет на сервере —
// перезагружаем страницу один раз (метка в sessionStorage защищает от бесконечной перезагрузки).
const CHUNK_RELOAD_KEY = "ms.chunkReloadAt";
router.onError((error, to) => {
  leavingPath = null;
  const message = String(error?.message || error || "");
  if (!/Loading (CSS )?chunk|dynamically imported module|ChunkLoadError/i.test(message)) return;
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - last < 30000) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (e) {}
  window.location.assign(to?.fullPath || window.location.href);
});
const originalReplace = router.replace.bind(router);
router.replace = (location) => {
  if (leavingPath && router.resolve(location).path === leavingPath) return Promise.resolve();
  return originalReplace(location);
};

router.beforeEach((to, from, next) => {
  let title = to?.meta?.title
    ? `${to?.meta?.title} | My Space`
    : "My Space | Smart System";
  try {
    if ((to.meta?.withParam || to?.meta?.withParamType) && to?.params) {
      const paramsKeys = Object.keys(to?.params);
      if (paramsKeys?.length)
        title = `${to.meta?.title ? `${to.meta?.title} ` : ""}${
          to?.meta?.withParamType ? "" : "#"
        }${
          to?.meta?.withParamType
            ? to.meta?.titles[to?.params[paramsKeys[0]]] ||
              to.meta?.defaultTitle ||
              ""
            : to?.params[paramsKeys[0]]
        } | My Space`;
    }
  } catch (e) {}
  document.title = TEST_SYSTEM ? `[ТЕСТ] ${title}` : title;
  next();
});

export default router;
export const notInitRoutes = routes
  .filter((item) => item.meta?.layout === "check" && !!item.meta?.routeHead)
  ?.map((item) => item.meta?.routeHead);
